// ABOUTME: OAuthStorage that keeps the OAuth nonce and PKCE verifier in localStorage (shared by all tabs)
// ABOUTME: and every other angular-oauth2-oidc key (tokens) in sessionStorage, as before (MAF-671).
import { OAuthStorage } from 'angular-oauth2-oidc';

/**
 * In the itsme same-device flow, the return from the itsme app completes the login in a
 * NEW browser tab (MAF-667). sessionStorage is per tab, so that tab had neither the nonce
 * nor the PKCE verifier written by initCodeFlow(), and tryLogin() rejected with
 * invalid_nonce_in_state. Only those two short-lived keys are shared across tabs; tokens
 * stay tab-scoped in sessionStorage.
 */
export class NonceSharingOAuthStorage implements OAuthStorage {
  private static readonly TAB_SHARED_KEYS = new Set(['nonce', 'PKCE_verifier']);

  getItem(key: string): string | null {
    return this.storeFor(key).getItem(key);
  }

  setItem(key: string, data: string): void {
    this.storeFor(key).setItem(key, data);
  }

  removeItem(key: string): void {
    this.storeFor(key).removeItem(key);
  }

  private storeFor(key: string): Storage {
    return NonceSharingOAuthStorage.TAB_SHARED_KEYS.has(key) ? localStorage : sessionStorage;
  }
}
